import { render } from "./Gene_Treatments.vue?vue&type=template&id=14bcd769"
import script from "./Gene_Treatments.vue?vue&type=script&lang=js"
export * from "./Gene_Treatments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__